<section class="home-operations-panel" *ngIf="columns.length" aria-label="Operações e consultas">
  <div class="home-operations-panel__groups">
    <div
      class="home-operations-panel__group"
      *ngFor="let column of columns; let last = last; trackBy: trackColumn">
      <div class="home-operations-panel__group-content">
        <div class="home-operations-panel__group-header">
          <h2 class="home-operations-panel__group-title">{{ column.title }}</h2>
          <div class="home-operations-panel__divider" aria-hidden="true"></div>
        </div>

        <div class="home-operations-panel__group-columns">
          <div
            class="home-operations-panel__column"
            *ngFor="let subsection of column.subsections; trackBy: trackSubsection">
            <h3 class="home-operations-panel__subsection-title">{{ subsection.title }}</h3>

            <div class="home-operations-panel__items">
              <app-home-action-item
                *ngFor="let item of subsection.items"
                [item]="item"
                (navigate)="onNavigate($event)">
              </app-home-action-item>
            </div>
          </div>
        </div>
      </div>

      <div class="home-operations-panel__group-divider" *ngIf="!last" aria-hidden="true"></div>
    </div>
  </div>
</section>
